import SignIn from './pages/SignIn';
import {BrowserRouter, MemoryRouter, Route, Routes} from 'react-router-dom';
import Sidebar from './components/sidebar/Sidebar';
import { ProtectedRoutes } from './components/ProtectedRoutes';
import { Redirect } from './components/Redirect';
import { baseUrl, chatbotData } from './components/constants';
import axios from 'axios';
import Dashboard from './pages/Dashboard';
import Chatbot from './components/cf-react-chatbot/Chatbot';
import { useState } from 'react';
import Culture from './pages/Culture/Culture';
import Engage from './pages/Engage/Engage';
import Develop from './pages/Develop/Develop';
import Grow from './pages/Grow/Grow';
import Reward from './pages/Reward/Reward';
import SystemLinks from './pages/SystemLinks/SystemLinks';
import config from './config';
import WorkforceAnalysis from "./pages/WorkforceAnalysis/WorkforceAnalysis";
import StaffComposition from "./pages/WorkforceAnalysis/StaffComposition";
import StaffAnalysis from "./pages/WorkforceAnalysis/StaffAnalysis";
import PerformanceDistribution from "./pages/Performance/PerformanceDistribution";
import BonusAllocation from "./pages/Remuneration/BonusAllocation";
import IncreaseAllocation from "./pages/Remuneration/IncreaseAllocation";
import TurnOverAnalysis from "./pages/WorkforceAnalysis/TurnOverAnalysis";
import Retirement from "./pages/WorkforceAnalysis/Retirement";
import EmploymentEquity from "./pages/WorkforceAnalysis/EmploymentEquity";
import Salaries from "./pages/Remuneration/Salaries";
import HelpSupport from "./pages/HelpSupport/HelpSupport";
import IssueLogForm from './pages/IssueLog/IssueLogForm';
import IssueLogs from './pages/IssueLog/IssueLog';
import LevelsOfWorkGradings from './pages/WorkArchitecture/LevelsOfWorkGradings';
import OutliersJobgradingVSBenchmark from './pages/WorkArchitecture/OutliersJobgradingVSBenchmark';
import RemVsBenchmarking from "./pages/Remuneration/RemVsBenchmarking";
import HeadcountParity from "./pages/Parity/HeadcountParity";
import EqualPayEqualWork from './pages/Parity/EqualPayEqualWork';
import ParityPay from './pages/Parity/ParityPay';
import PerformanceVReward from './pages/Parity/PerformanceVReward';
import APIManagement from "./pages/APIManagement/APIManagement";
import PersonnelAdminIndex from "./pages/PersonnelAdmin/PersonnelAdminIndex";
import Upload from "./pages/Upload/Upload";

const App = () => {
  const [showChatbot, setShowChatbot] = useState(false);
  const [conversation,setConversation] = useState([]);
  const [question,setQuestion]= useState();
  const token = localStorage.getItem("token");
  //axios.defaults.baseURL = "http://localhost:8000/api/";
  axios.defaults.baseURL = config.apiUrl;
  axios.interceptors.request.use(
    async (config) => {
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      config.credentials = 'include'; // Set the "credentials" option to "include"
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(async (response) => {
    return response;
  }, async function (error) {
    const originalRequest = error.config;
    // console.log(originalRequest)
    if (error.response.status === 401) { localStorage.removeItem('token'); window.location.reload(true); }
    if (error.response.status === 408) { localStorage.removeItem('token'); window.location.reload(true); }
    return Promise.reject(error);
  });

const getConversation = ()=>{
  axios.get("getConversations").then((res)=>{
    setConversation(res.data.data)
  }).catch(()=>{

  })
}
const createQuestion = ()=>{
  axios.post("createQuestion",{question}).then((res)=>{
    getConversation();
    setQuestion("");
  }).catch(()=>{

  })
}


  return (
    <>
     
      {
 <button className="chatbot-toggler shadow ">
<span className="material-symbols-rounded">
  <div className="bot-icon-container" onClick={() => { setShowChatbot((val) => { return !val }) }}>
    {showChatbot && <i class="fa-solid fa-xmark text-light"></i>}
    {!showChatbot && <i class="fa-solid fa-message text-light"></i>}
  </div>
  {showChatbot && <div className='position-absolute chatbot-package shadow rounded-4'>
    <Chatbot
      data={chatbotData}
      getConversation={getConversation }
      conversation = {conversation}
      // onClose={()=>{ toggleBot(false)}}
      onChange = {(value)=>{ setQuestion(value)}}
      onClose={() => { }}
      onSubmit={() => { createQuestion() }}
    />
  </div>
  }
</span>
</button>
      }
      <MemoryRouter>
        {/*{token && <Sidebar />}*/}
        <Sidebar />
        <Routes >
          <Route exact path="/" element={<ProtectedRoutes element={<Dashboard />} />} />
          <Route path="/culture" element={<ProtectedRoutes element={< Culture />} />} />
          <Route path="/engage" element={<ProtectedRoutes element={< Engage />} />} />
          <Route path="/learn" element={<ProtectedRoutes element={< Develop />} />} />
          <Route path="/grow" element={<ProtectedRoutes element={< Grow />} />} />
          <Route path="/reward" element={<ProtectedRoutes element={< Reward />} />} />
          <Route path="/system-links" element={<ProtectedRoutes element={< SystemLinks />} />} />
          <Route path="/workforce-analysis" element={<ProtectedRoutes element={< WorkforceAnalysis />} />} />
          <Route path="/staff-composition" element={<ProtectedRoutes element={< StaffComposition />} />} />
          <Route path="/staff-analysis" element={<ProtectedRoutes element={< StaffAnalysis />} />} />
          <Route path="/performance-distribution" element={<ProtectedRoutes element={<PerformanceDistribution />} />} />
          <Route path="/salaries" element={<ProtectedRoutes element={<Salaries />} />} />
          <Route path="/bonus-allocation" element={<ProtectedRoutes element={<BonusAllocation />} />} />
          <Route path="/increase-allocation" element={<ProtectedRoutes element={<IncreaseAllocation />} />} />
          <Route path="/turn-over-analysis" element={<ProtectedRoutes element={<TurnOverAnalysis />} />} />
          <Route path="/Retirement" element={<ProtectedRoutes element={<Retirement />} />} />
          <Route path="/employment-equity" element={<ProtectedRoutes element={<EmploymentEquity />} />} />
          <Route path="/help-support" element={<ProtectedRoutes element={<HelpSupport/>} />} />
          <Route path="/issue-logs" element={<ProtectedRoutes element={<IssueLogs/>} />} />
          <Route path="/issue-logs/add" element={<ProtectedRoutes element={<IssueLogForm/>} />} />
          <Route path="/issue-logs/:id" element={<ProtectedRoutes element={<IssueLogForm/>} />} /> 
          <Route path="/job-families-levels-work-Grading" element={<ProtectedRoutes element={<LevelsOfWorkGradings/>} />} />
          <Route path="/outliers-job-jobgrading-vs-benchmark" element={<ProtectedRoutes element={<OutliersJobgradingVSBenchmark/>} />} />
          <Route path="/rem-vs-benchmarking" element={<ProtectedRoutes element={<RemVsBenchmarking/>} />} />
          <Route path="/headcount-parity" element={<ProtectedRoutes element={<HeadcountParity/>} />} />
          <Route path="/outliers-job-jobgrading-vs-benchmark" element={<ProtectedRoutes element={<OutliersJobgradingVSBenchmark/>} />} />
          <Route path="/equal-pay-for-equal-work" element={<ProtectedRoutes element={<EqualPayEqualWork/>} />} /> 
          <Route path="/reward-parity" element={<ProtectedRoutes element={<ParityPay/>} />} /> 
          <Route path="/performance-rem" element={<ProtectedRoutes element={<PerformanceVReward/>} />} />

          <Route path="/upload" element={<ProtectedRoutes element={< Upload />} />} />
          <Route path="/api-management" element={<ProtectedRoutes element={< APIManagement />} />} />
          <Route path="/personnel-admin" element={<ProtectedRoutes element={< PersonnelAdminIndex />} />} />
        </Routes>
        <Routes>
          <Route path="/login" element={<Redirect element={< Dashboard />} />} />
        </Routes>
      </MemoryRouter>
    </>
  );
}

export default App;
